import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { LoggedInUserService } from 'src/app/core/services/logged-in-user.service';

@Directive({
    selector: '[ifSuperAdminSectionManagerAdminGeneralManager]'
})
export class IfSuperAdminSectionManagerAdminDirective {
    constructor(
        private readonly userService: LoggedInUserService,
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef
    ) {
        if (
            this.userService.isSuperAdmin() ||
            this.userService.isSectionManager() ||
            this.userService.isAdmin() ||
            this.userService.isGeneralManager() ||
            this.userService.IsUserRelatedQualityAssurance() ||
            this.userService.isShiftManagerIC()
        ) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
    }
}
